/* global __VERSION__, __DEV__ */

export const LA2_ID = 'la2';

export const FIREBASE = {
  apiKey: 'AIzaSyAIeudM0cX1dqiXe7S57TFcNlStHdnC56c',
  authDomain: 'little-alchemy-2.firebaseapp.com',
  databaseURL: 'https://little-alchemy-2.firebaseio.com',
  storageBucket: 'little-alchemy-2.appspot.com',
  messagingSenderId: '970099188369',
};

export const CHECK_UNDER_LIBRARY_DELAY = 2 * 1000;
export const HINTS_URL = 'https://hints.littlealchemy2.com';
export const SYNC_START_TIMESTAMP = 1496268000;

export const ANALYTICS_UID = 'UA-102724536-2';
export const FEEDBACK_URL = 'https://help.littlealchemy2.com';

export const VERSION = __VERSION__;

export const POPUPS_TESTING = __DEV__;

export const CONFIG_LIBRARY_SORTING_ENABLED = false;


export const CONFIG_ADVENTURE_ENABLED = false;
export const DLC_ID = '';
